import { ChartController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Controller rendering chart by provided config
 * Config type example: config: ChartConfiguration<"pie" | "bar", { labels: string[]; datasets: any[] }, any>
 * Config follows official chart.js ChartConfiguration interface
 * @example
 * ```html
 *  <salaxy-chart config="config"></salaxy-chart>
 * ```
 */
export class Chart extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {
      /** Config of chart */
      config: "<",
      /** Custom height of chart */
      customHeight: "@",
      /** Custom height of chart */
      customWidth: "@",
      /** Custom height of chart */
      customClass: "@",
    };

    /** Uses the ChartController */
    public controller = ChartController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/helpers/Chart.html";
}
